import React from "react"

import { useStaticQuery, graphql } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

import PageSection from "../../pageSection/pageSection.js"
import H2 from "../../h2/h2.js"
import P from "../../p/p.js"
import QR from "../../qrcode/qrcode"

import styles from "./bankingFees.module.scss"

import googlePlayImage from "../../../images/android/Google_Play.svg"
import appStoreImage from "../../../images/apple-app-store.svg"

const BankingFeesSection = (props) => {
  const data = useStaticQuery(graphql`
    query {
      kidsAtPicnicTableImage: file(relativePath: { eq: "home/kids-at-picnic-table.png" }) {
        childImageSharp {
          gatsbyImageData (
            width: 730
            placeholder: BLURRED
            formats: [AUTO, WEBP, AVIF]
          )
        }
      }
    }
  `)
  const branchLink = props.ccCode ? `sayiDSdmgfb?campaignCode=${props.ccCode}` : "sayiDSdmgfb";
  const bgColor = "#EFF3F8";

  return (
    <PageSection
      backgroundColor="#eff3f9"
      centerVertical
      RightComponent={() =>
        <div className={styles.kidsPicnicContainer}>
          <GatsbyImage
            image={getImage(data.kidsAtPicnicTableImage)}
            alt="Group of four students looking at the Till card that one of them is holding in his hands"
            width={750}
          />
        </div>
      }
    >
      <div className={styles.feesCopyContainer}>
        <H2 slideUp>
          Banking fees are for adults.
        </H2>
        <P className={styles.body}>
          And even that’s debatable. Our fee-free platform is designed to give kids the freedom to focus on spending savvy, not paying fees.
        </P>
          {props.device === "ios" &&
            <a className={styles.appStoreImg} href={`${process.env.BRANCH_BASE_URL}/${branchLink}`} target="_blank" rel="noreferrer">
              <img src={appStoreImage} alt="Download on the App Store" layout="fixed" />
            </a>
          }
          {props.device === "android" &&
            <a className={styles.googlePlayImg} href={`${process.env.BRANCH_BASE_URL}/${branchLink}`} target="_blank" rel="noreferrer">
              <img src={googlePlayImage} alt="Download on the Google Play Store Store" layout="fixed" />
            </a>
          }
          {props.device !== "android" && props.device !== "ios"  &&
            <div className={styles.qrCodeContainer}>
              <p>Scan this code with your phone’s camera to download Till.</p>
              <QR bgColor={bgColor} url={`${process.env.BRANCH_BASE_URL}/${branchLink}`} size={128} height={128} width={128} />
            </div>
          }
        
      </div>
    </PageSection>
  )
}

export { BankingFeesSection }
